<template>
	<v-container>
		<v-row>
			<v-col
					v-if="$vuetify.breakpoint.mdAndUp"
					lg="4"
					md="4"
					xl="4"
			>
				<v-card
						:rounded="$vuetify.breakpoint.smAndDown ? '0' : 'lg'"
						class="mt-4"
				>
					<v-card-title class="pb-0">
						{{ $t("pages.lessons.lessonsManagement") }}
					</v-card-title>
					<v-list expand>
						<v-list-item :to="{ name: 'upcomingLessons' }">
							<v-list-item-icon class="mr-2">
								<v-icon>mdi-message-video</v-icon>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title>
									{{ $t("pages.lessons.upcomingLessons") }}
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item :to="{ name: 'pastLessons' }">
							<v-list-item-icon class="mr-2">
								<v-icon>mdi-video-check-outline</v-icon>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title>
									{{ $t("pages.lessons.pastLessons") }}
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-card>
			</v-col>
			<v-col
					class="px-sm-only-0 px-xs-0"
					lg="8"
					md="8"
					xl="8"
			>
				<v-tabs
						v-if="$vuetify.breakpoint.smAndDown"
						grow
				>
					<v-tab
							:to="{ name: 'upcomingLessons' }"
							class="no-uppercase"
					>
						{{ $t("pages.lessons.upcomingLessons") }}
					</v-tab>
					<v-tab
							:to="{ name: 'pastLessons' }"
							class="no-uppercase"
					>
						{{ $t("pages.lessons.pastLessons") }}
					</v-tab>
				</v-tabs>
				<router-view class="mt-4" />
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { handleGqlResponseBody } from "@/utils/apollo.util";
import { GET_SELF_USER_CONNECTION_COUNTS_QUERY } from "@/graphql/queries/connection/get-self-user-connection-counts.query";
import { loadingByKeyLaterInitMixin } from "@/mixins/loading-by-key-later-init.mixin";
import { errorByKeyLaterInitMixin } from "@/mixins/error-by-key-later-init.mixin";

const USER_CONNECTION_COUNTS_KEY = "selfUserConnectionCounts";
export default {
  components: {},
  mixins: [loadingByKeyLaterInitMixin, errorByKeyLaterInitMixin],
  data() {
    return {
      tab: "pending-connections",
      counts: {
        pendingSharedContacts: null,
        connections: null,
        pendingConnections: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "getCurrentUser",
    }),
    USER_CONNECTION_COUNTS_KEY: () => USER_CONNECTION_COUNTS_KEY,
  },
  created() {
    this.initLoadingByKey(USER_CONNECTION_COUNTS_KEY);
    this.initErrorByKey(USER_CONNECTION_COUNTS_KEY);
  },
  async mounted() {
    await this.loadCounts();
  },
  methods: {
    async loadCounts() {
      this.setLoadingByKey(USER_CONNECTION_COUNTS_KEY, true);
      await this.$showGqlError(
        async () => {
          const result = await handleGqlResponseBody((apollo) => {
            return apollo.query({
              query: GET_SELF_USER_CONNECTION_COUNTS_QUERY,
              fetchPolicy: "no-cache",
            });
          });

          this.counts.pendingSharedContacts = result.pendingSharedContacts;
          this.counts.connections = result.connections;
          this.counts.pendingConnections = result.pendingConnections;

          this.setLoadingByKey(USER_CONNECTION_COUNTS_KEY, false);
          this.clearErrorsByKey(USER_CONNECTION_COUNTS_KEY);
        },
        (_, { handledErrors }) => {
          this.setLoadingByKey(USER_CONNECTION_COUNTS_KEY, false);
          this.setErrorsByKey(USER_CONNECTION_COUNTS_KEY, handledErrors);
        }
      );
    },
  },
};
</script>
